//import React from 'react';
//import ReactDOM from 'react-dom';
import '../index.css';

const MovieCastData= [
    {
        character: "Tony Stark / Iron Man",
        gender: 2,
        id: 3223,
        name: "Robert Downey Jr",
        profile_path: "marc-houben-pasfoto.jpg",
        description: "Gewond, gevangen genomen en gedwongen een wapen te bouwen door zijn vijanden."
    },
    {
        character: "Loki",
        gender: 2,
        id: 91606,
        name: "Ton Hiddleston",
        profile_path: "marc-houben-in-kinderwagen.jpg",
        description: "Loki Laufeyson was de biologische zoon van Laufey, de heerser van de Frost Giants."
    },
    {
        character: "Natascha Romanoff / Black Widow",
        gender: 1,
        id: 1245,
        name: "Scarlett Johansson",
        profile_path: "britney-spears-kralen-boezem.jpg",
        description: "Black Widow was een van de meest getalenteerde spionnen en huurmoordenaars ter wereld."
    },
    {
        character: "Bruce banner / Hulk",
        gender: 2,
        id: 103,
        name: "Mark Ruffalo",
        profile_path: "barbara-carrera.jpg",
        description: "Gevangen in een gamma-bom explosie werd Dr Bruce Banner getransformeerd in de Hulk."
    },
];

export default MovieCastData;